export default {"src":"/_next/static/media/0x503234f203fc7eb888eec8513210612a43cf6115.38635f67.svg","height":127,"width":127,"blurWidth":0,"blurHeight":0};